import type { ReceiptAnalysisRequest, ReceiptAnalysisResults } from '../types/receipt/receipt';
import { apiClient } from '../utils/apiClient';

/**
 * Analyze receipt image using Gemini AI service
 * @param imageData Base64-encoded image data (with data URL prefix)
 * @param mimeType MIME type of the image
 * @returns Analysis results with description, category ID, and amount
 */
export async function analyzeReceipt(
  imageData: string,
  mimeType: string,
): Promise<ReceiptAnalysisResults> {
  const requestData: ReceiptAnalysisRequest = {
    imageData,
    mimeType,
  };

  const response = await apiClient.post<ReceiptAnalysisResults>('/receipts/analyze', requestData);
  return response.data;
}
